"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.string.pad-start");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _cmsSpecialApply = require("@/api/cmsSpecialApply");

var _contract = require("@/api/cms/contract");

var _order = require("@/api/cms/order");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _Dict = _interopRequireDefault(require("@/components/Dict/Dict"));

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'ContractSpecialApply',
  components: {
    CommonUpload: _commonUpload.default,
    Dict: _Dict.default
  },
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  dicts: ['order_receiving_account', 'order_payment_reason'],
  data: function data() {
    return {
      specialApplyList: [],
      showDetailDialog: false,
      currentApplyDetail: null,
      showSpecialApplyDialog: false,
      isEditMode: false,
      currentEditApply: null,
      specialApplyFiles: [],
      contractOrders: [],
      specialApplyForm: {
        applyType: '特殊申请',
        title: '',
        applicationDetails: '',
        detailedDescription: '',
        isMaterial: '',
        isProofing: '',
        custAddress: '',
        applyDate: '',
        applyReason: '',
        custName: '',
        remark: '',
        salesType: '',
        contractIds: [],
        contractNo: '',
        orderNo: [],
        orderDate: '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        urgentAfterReorder: '',
        payReason: '',
        totalAmount: '',
        receivingAccount: '',
        productionOrder: ''
      }
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['imgPreviewPrefix', 'filePreviewPrefix'])),
  mounted: function mounted() {
    this.initSpecialApplyList();
  },
  watch: {
    contract: {
      handler: function handler(newVal) {
        if (newVal) {
          this.initSpecialApplyList();
        }
      },
      deep: true
    }
  },
  methods: {
    // 格式化日期，只显示日期部分
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '';

      if (typeof dateStr === 'string' && dateStr.length === 10) {
        return dateStr;
      }

      if (dateStr instanceof Date) {
        var year = dateStr.getFullYear();
        var month = String(dateStr.getMonth() + 1).padStart(2, '0');
        var day = String(dateStr.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
      }

      if (typeof dateStr === 'string') {
        return dateStr.split(' ')[0];
      }

      return dateStr;
    },
    formatAccount: function formatAccount(account) {
      if (!account) return '';
      return account.replace(/\|/g, '<br/>');
    },
    formatOrderNos: function formatOrderNos(orderNos) {
      if (!orderNos) return '';
      return orderNos.replace(/,/g, '<br/>');
    },
    // 订单选择变化时计算总金额
    handleOrderChange: function handleOrderChange(orderNos) {
      var _this = this;

      if (orderNos && orderNos.length > 0) {
        var totalAmount = 0;
        orderNos.forEach(function (orderNo) {
          var order = _this.contractOrders.find(function (o) {
            return o.productionOrder === orderNo;
          });

          if (order && order.totalPrice) {
            totalAmount += parseFloat(order.totalPrice);
          }
        });
        this.specialApplyForm.totalAmount = totalAmount;
      } else {
        this.specialApplyForm.totalAmount = '';
      }
    },
    // 初始化特殊申请列表
    initSpecialApplyList: function initSpecialApplyList() {
      var _this2 = this;

      if (this.contract.id) {
        // 构建请求参数
        var params = {
          contractId: this.contract.id
        }; // 调用获取特殊申请记录的接口

        (0, _contract.getContractSpecialApplyList)(params).then(function (response) {
          if (response.code === 200) {
            // 处理返回的特殊申请记录数据
            _this2.specialApplyList = response.data.map(function (item) {
              return {
                id: item.rowId,
                applyType: item.applyType,
                title: item.title,
                applyStatus: item.applyStatus,
                contractId: item.contractId,
                contractNo: item.contractNo,
                contractStatus: item.contractStatus,
                applicationDetails: item.applicationDetails,
                detailedDescription: item.detailedDescription,
                isFile: item.isFile,
                isMaterial: item.isMaterial,
                isProofing: item.isProofing,
                custAddress: item.custAddress || item.contactAddress || _this2.contract && _this2.contract.contactAddress || '',
                custName: item.custName || item.contactPerson || _this2.contract && _this2.contract.contactPerson || '',
                applyDate: item.applyDate,
                applyReason: item.applyReason,
                salesType: item.salesType,
                remark: item.remark,
                file: item.file,
                orderDate: item.orderDate || '',
                orderApprovalDate: item.orderApprovalDate || item.orderApprovalDate || '',
                plannedDeliveryDate: item.plannedDeliveryDate || '',
                urgentAfterReorder: item.urgentAfterReorder || '',
                productionOrder: item.productionOrder || item.productionOrders || '',
                payReason: item.payReason || '',
                totalAmount: item.totalAmount || '',
                receivingAccount: item.receivingAccount || '',
                createBy: item.createUserName,
                createUserName: item.createUserName,
                // 新增字段用于表格显示
                createTime: item.createTime,
                updateTime: item.updateTime,
                wxAuditId: item.wxAuditId
              };
            });
          } else {
            _this2.$message.error(response.msg || '获取特殊申请记录失败');

            _this2.specialApplyList = [];
          }
        }).catch(function (error) {
          console.error('获取特殊申请记录失败:', error);

          _this2.$message.error('网络错误，请重试');

          _this2.specialApplyList = [];
        });
      }
    },
    // 处理附件上传成功
    handleFileUpload: function handleFileUpload(filePaths) {
      var _this3 = this;

      this.specialApplyFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 检查图片格式是否为jpg或png

          if (fileObj.type === '图片') {
            var fileName = fileObj.realName.toLowerCase();

            if (!fileName.endsWith('.jpg') && !fileName.endsWith('.png')) {
              _this3.$message.error('图片只能上传jpg和png格式');

              return;
            }
          } // 直接将接口返回的数据包添加到 specialApplyFiles 中


          _this3.specialApplyFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this3.$message.error('解析文件数据失败，请重试');
        }
      });
      this.$message.success('附件上传成功');
    },
    // 处理附件删除成功
    handleFileDelete: function handleFileDelete(filePaths) {
      var _this4 = this;

      this.specialApplyFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 直接将接口返回的数据包添加到 specialApplyFiles 中

          _this4.specialApplyFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this4.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 删除附件
    delFileByIndex: function delFileByIndex(index) {
      if (this.specialApplyFiles && this.specialApplyFiles.length > index) {
        // 从 specialApplyFiles 数组中删除附件
        this.specialApplyFiles.splice(index, 1); // 不要更新 CommonUpload 组件的 fileList 和 filePaths，避免删除的附件出现在上方上传组件中
      }
    },
    // 下载文件
    downloadFile: function downloadFile(url) {
      if (!url) return;
      fetch(url, {
        mode: 'cors'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = url.substring(url.lastIndexOf('/') + 1) || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }).catch(function () {
        window.open(url, '_blank');
      });
    },
    // 处理下拉菜单命令
    handleDropdownCommand: function handleDropdownCommand(command) {
      this.openSpecialApplyDialog(command);
    },
    // 显示申请详情
    showApplyDetail: function showApplyDetail(apply) {
      this.currentApplyDetail = apply;
      this.showDetailDialog = true;
    },
    // 打开添加特殊申请弹窗
    openSpecialApplyDialog: function openSpecialApplyDialog() {
      var _this5 = this;

      var applyType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '特殊申请';
      // 重置表单数据
      this.isEditMode = false;
      this.currentEditApply = null;
      var defaultForm = {
        applyType: applyType,
        title: '',
        applicationDetails: '',
        detailedDescription: '',
        isMaterial: '',
        isProofing: '',
        custAddress: '',
        applyDate: '',
        applyReason: '',
        custName: '',
        remark: '',
        salesType: '',
        contractIds: [],
        contractNo: '',
        orderNo: [],
        orderDate: '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        urgentAfterReorder: '',
        payReason: '',
        totalAmount: '',
        receivingAccount: ''
      }; // 自动填充合同ID和合同号和客户信息

      if (this.contract) {
        defaultForm.contractIds = [this.contract.id];
        defaultForm.contractNo = this.contract.contractNo; // 自动填充客户姓名和地址

        defaultForm.custName = this.contract.contactPerson || '';
        defaultForm.custAddress = this.contract.contactAddress || ''; // 自动填充订单号

        if (this.contract.contractNo) {
          // 调用接口查询订单号
          (0, _order.getCmsCustDesignSchemeAuditList)({
            contractNumber: this.contract.contractNo
          }).then(function (response) {
            if (response.code === 200) {
              // 保存订单列表
              _this5.contractOrders = response.data; // 自动填充第一个订单号和下单时间

              if (response.data && response.data.length > 0) {
                defaultForm.orderNo = [response.data[0].productionOrder];
                defaultForm.orderDate = response.data[0].createTime || ''; // 自动填充总金额

                defaultForm.totalAmount = response.data[0].totalPrice ? parseFloat(response.data[0].totalPrice) : '';
              } else {
                defaultForm.orderNo = [];
                defaultForm.orderDate = '';
                defaultForm.totalAmount = '';
              } // 更新表单


              _this5.specialApplyForm = _objectSpread({}, defaultForm);
            }
          }).catch(function (error) {
            console.error('查询订单号失败:', error);
            _this5.specialApplyForm = _objectSpread({}, defaultForm);
          });
        } else {
          this.specialApplyForm = _objectSpread({}, defaultForm);
        }
      } else {
        this.specialApplyForm = _objectSpread({}, defaultForm);
      }

      this.specialApplyFiles = []; // 清空附件上传组件的文件列表

      if (this.$refs.specialApplyFileUpload) {
        this.$refs.specialApplyFileUpload.clearImgs();
      } // 结案申请默认申请日期为当天


      if (applyType === '结案申请' || applyType === '加急申请') {
        var today = new Date();
        var year = today.getFullYear();
        var month = String(today.getMonth() + 1).padStart(2, '0');
        var day = String(today.getDate()).padStart(2, '0');
        defaultForm.applyDate = "".concat(year, "-").concat(month, "-").concat(day);
      } // 打开弹窗


      this.showSpecialApplyDialog = true;
    },
    // 保存特殊申请
    saveSpecialApply: function saveSpecialApply() {
      var _this6 = this;

      // 根据申请类型进行不同的表单验证
      var applyType = this.specialApplyForm.applyType;

      if (applyType === '特殊申请') {
        if (!this.specialApplyForm.title) {
          this.$message.error('申请标题不能为空');
          return;
        }

        if (!this.specialApplyForm.applicationDetails) {
          this.$message.error('申请明细不能为空');
          return;
        }

        if (!this.specialApplyForm.detailedDescription) {
          this.$message.error('明细描述不能为空');
          return;
        }

        if (!this.specialApplyForm.isMaterial) {
          this.$message.error('是否在签订回执后购买物料不能为空');
          return;
        }

        if (!this.specialApplyForm.isProofing) {
          this.$message.error('是否需要打样不能为空');
          return;
        }

        if (!this.specialApplyForm.custAddress) {
          this.$message.error('客户地址不能为空');
          return;
        }
      } else if (applyType === '加急申请') {
        if (!this.specialApplyForm.applyDate) {
          this.$message.error('申请日期不能为空');
          return;
        }

        if (!this.specialApplyForm.applyReason) {
          this.$message.error('申请原因不能为空');
          return;
        }

        if (!this.specialApplyForm.custName) {
          this.$message.error('客户姓名不能为空');
          return;
        }

        if (!this.specialApplyForm.custAddress) {
          this.$message.error('客户地址不能为空');
          return;
        }
      } else if (applyType === '结案申请') {
        if (!this.specialApplyForm.custName) {
          this.$message.error('客户名称不能为空');
          return;
        }

        if (!this.specialApplyForm.custAddress) {
          this.$message.error('客户地址不能为空');
          return;
        }

        if (!this.specialApplyForm.orderDate) {
          this.$message.error('下单日期不能为空');
          return;
        }

        if (!this.specialApplyForm.applyDate) {
          this.$message.error('申请日期不能为空');
          return;
        }

        if (!this.specialApplyForm.applyReason) {
          this.$message.error('申请原因不能为空');
          return;
        }

        if (!this.specialApplyForm.urgentAfterReorder) {
          this.$message.error('取消后重新下单是否需要加急不能为空');
          return;
        }
      } else if (applyType === '报价确认申请') {
        if (!this.specialApplyForm.payReason) {
          this.$message.error('付款事由不能为空');
          return;
        }

        if (!this.specialApplyForm.totalAmount) {
          this.$message.error('总金额不能为空');
          return;
        }

        if (!this.specialApplyForm.receivingAccount) {
          this.$message.error('收款账户不能为空');
          return;
        }

        if (!this.specialApplyForm.orderNo || this.specialApplyForm.orderNo.length === 0) {
          this.$message.error('销售单号不能为空');
          return;
        }
      } // 合并 specialApplyFiles 中的文件与新上传的文件


      var uploadedFiles = []; // 首先添加 specialApplyFiles 中的文件（已删除的文件不会在这个数组中）

      if (this.specialApplyFiles && this.specialApplyFiles.length > 0) {
        this.specialApplyFiles.forEach(function (file) {
          uploadedFiles.push(file);
        });
      } // 然后添加新上传的文件


      if (this.$refs.specialApplyFileUpload && this.$refs.specialApplyFileUpload.filePaths) {
        this.$refs.specialApplyFileUpload.filePaths.forEach(function (fileStr) {
          try {
            var fileObj = JSON.parse(fileStr); // 检查是否已存在相同的文件，避免重复添加

            var isDuplicate = uploadedFiles.some(function (existingFile) {
              return existingFile.realName === fileObj.realName;
            });

            if (!isDuplicate) {
              uploadedFiles.push(fileObj);
            }
          } catch (error) {
            console.error('解析文件数据失败:', error);
          }
        });
      } // 报价确认申请和加急申请附件必填验证


      if ((applyType === '报价确认申请' || applyType === '加急申请') && uploadedFiles.length === 0) {
        this.$message.error('附件不能为空');
        return;
      }

      console.log('上传文件:', this.specialApplyFiles);
      console.log('保存文件:', uploadedFiles); // 构建请求参数

      var params = {
        contractIds: [this.contract.id],
        contractNo: this.contract.contractNo,
        applyType: this.specialApplyForm.applyType,
        title: this.specialApplyForm.title,
        applicationDetails: this.specialApplyForm.applicationDetails,
        detailedDescription: this.specialApplyForm.detailedDescription,
        isFile: uploadedFiles.length > 0 ? '是' : '否',
        isMaterial: this.specialApplyForm.isMaterial,
        isProofing: this.specialApplyForm.isProofing,
        custAddress: this.specialApplyForm.custAddress,
        applyDate: this.specialApplyForm.applyDate,
        applyReason: this.specialApplyForm.applyReason,
        custName: this.specialApplyForm.custName,
        remark: this.specialApplyForm.remark,
        salesType: this.specialApplyForm.salesType,
        orderDate: this.specialApplyForm.orderDate,
        orderApprovalDate: this.specialApplyForm.orderApprovalDate,
        plannedDeliveryDate: this.specialApplyForm.plannedDeliveryDate,
        urgentAfterReorder: this.specialApplyForm.urgentAfterReorder,
        payReason: this.specialApplyForm.payReason,
        totalAmount: this.specialApplyForm.totalAmount,
        receivingAccount: this.specialApplyForm.receivingAccount,
        productionOrder: this.specialApplyForm.productionOrder
      }; // 只有当附件不为空时才添加files参数

      if (uploadedFiles.length > 0) {
        params.files = uploadedFiles;
      } // 非特殊申请添加订单号


      if (this.specialApplyForm.applyType !== '特殊申请') {
        params.productionOrders = this.specialApplyForm.orderNo;
      } // 根据申请类型调用不同的接口


      var requestParams = _objectSpread({}, params);

      var apiPromise = null; // 处理文件参数

      if (applyType === '特殊申请') {
        apiPromise = (0, _contract.addContractSpecialApply)(requestParams);
      } else if (applyType === '加急申请') {
        // 移除不需要的字段
        delete requestParams.applicationDetails;
        delete requestParams.detailedDescription;
        delete requestParams.isMaterial;
        delete requestParams.isProofing;
        delete requestParams.isFile;
        apiPromise = (0, _contract.addContractUrgentApply)(requestParams);
      } else if (applyType === '结案申请') {
        // 移除不需要的字段
        delete requestParams.applicationDetails;
        delete requestParams.detailedDescription;
        delete requestParams.isMaterial;
        delete requestParams.isProofing;
        delete requestParams.isFile; // 结案申请使用表单中的值

        apiPromise = (0, _contract.addContractAfterSalesApply)(requestParams);
      } else if (applyType === '报价确认申请') {
        // 移除不需要的字段
        delete requestParams.applicationDetails;
        delete requestParams.detailedDescription;
        delete requestParams.isMaterial;
        delete requestParams.isProofing;
        delete requestParams.isFile;
        delete requestParams.applyDate;
        delete requestParams.applyReason;
        apiPromise = (0, _contract.addContractPaySalesApply)(requestParams);
      }

      console.log("\u63D0\u4EA4".concat(applyType, ":"), requestParams); // 调用实际的接口

      apiPromise.then(function (response) {
        if (response.code === 200) {
          _this6.$message.success("".concat(applyType, "\u63D0\u4EA4\u6210\u529F"));

          _this6.showSpecialApplyDialog = false; // 重置表单数据

          _this6.specialApplyForm = {
            applyType: applyType,
            applicationDetails: '',
            detailedDescription: '',
            isMaterial: '',
            isProofing: '',
            custAddress: '',
            applyDate: '',
            applyReason: '',
            custName: '',
            remark: '',
            salesType: '',
            contractIds: [],
            contractNo: '',
            orderDate: '',
            orderApprovalDate: '',
            plannedDeliveryDate: '',
            urgentAfterReorder: ''
          };
          _this6.specialApplyFiles = []; // 刷新列表

          _this6.initSpecialApplyList();
        } else {
          _this6.$message.error(response.msg || '提交失败');
        }
      }).catch(function (error) {
        console.error("\u63D0\u4EA4".concat(applyType, "\u5931\u8D25:"), error);

        _this6.$message.error('提交失败');
      });
    },
    // 解析特殊申请中的附件数据
    parseSpecialApplyFile: function parseSpecialApplyFile(fileData) {
      try {
        if (typeof fileData === 'string') {
          var files = JSON.parse(fileData);
          return this.processFiles(files);
        } else if (Array.isArray(fileData)) {
          return this.processFiles(fileData);
        }
      } catch (error) {
        console.error('解析附件数据失败:', error);
      }

      return [];
    },
    // 处理文件数据，添加完整的URL
    processFiles: function processFiles(files) {
      var _this7 = this;

      return files.map(function (file) {
        var url = file.url;

        if (!url) {
          if (file.type === '图片') {
            url = _this7.imgPreviewPrefix + file.realName;
          } else {
            url = _this7.filePreviewPrefix + file.realName;
          }
        }

        return _objectSpread(_objectSpread({}, file), {}, {
          url: url
        });
      });
    },
    // 根据申请类型获取样式类
    getApplyTypeClass: function getApplyTypeClass(applyType) {
      switch (applyType) {
        case '特殊申请':
          return 'apply-type-special';

        case '加急申请':
          return 'apply-type-urgent';

        case '结案申请':
          return 'apply-type-close';

        case '报价确认申请':
          return 'apply-type-quote';

        default:
          return 'apply-type-special';
      }
    }
  }
};
exports.default = _default2;